import React from 'react';
import PropTypes from 'prop-types';

import GenericDialog from '../GenericDialog';
import ChangePassword from './ChangePassword';

const ChangePasswordDialog = ({ isOpen, onPasswordSubmit, onClose }) => (
  <GenericDialog isOpen={isOpen}>
    <ChangePassword
      onSubmit={onPasswordSubmit}
      onClose={onClose}
    />
  </GenericDialog>
);

ChangePasswordDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onPasswordSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ChangePasswordDialog;
